const initialState = {
  snackbarStatus: {
    showSnackbar: false,
    message: '',
    severity: ''
  }
};

const GenericReducer = (state = initialState, action) => {
  if (action.type === 'SET_SNACKBAR') {
    return {
      ...state,
      snackbarStatus: action.payload
    };
  } else {
    return state;
  }
};

export default GenericReducer;
